<template>
  <div>
    <b-modal
      id="modal-recruit-job-posting"
      ref="modal_recruit_job_posting"
      :title="title"
      size="xl"
      lazy
      centered
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      @hidden="onHidden"
    >
      <b-skeleton-wrapper :loading="isBusy">
        <template #loading>
          <b-form>
            <b-card bg-variant="light">
              <b-row class="mt-2 mb-2">
                <b-col cols="3">
                  <b-skeleton width="21%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col cols="3">
                  <b-skeleton width="53%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="13%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="5%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="35%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="42%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-5">
                <b-col>
                  <b-skeleton width="10%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="109%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="9%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="9%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="5%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
            </b-card>
          </b-form>
        </template>

        <template #default>
          <b-form>
            <b-row>
              <b-col lg="6">
                <b-card bg-variant="light">
                  <b-row class="align-items-end">
                    <b-col cols="6">
                      <b-form-group id="group-recruit-task-id-select" label="Заявка на подбор">
                        <recruit-task-select
                          size="sm"
                          ref="recruit_task_id_select"
                          :is-disabled="selectDisabled || isViewDisabled"
                          :value="newItem.recruit_task_id"
                          @onSelect="onRecruitTaskIdSelect"
                          @onClear="onClearSelected"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group id="group-vacancy" label="Вакансия">
                        <b-form-input
                            type="text"
                            size="sm"
                            :disabled="isDisabled"
                            v-model="newItem.location_vacancy_name"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-form-group id="group-location" label="Объект">
                    <b-form-input
                      type="text"
                      size="sm"
                      :disabled="isDisabled"
                      v-model="newItem.location_name"
                    />
                  </b-form-group>
                  <b-form-group id="group-location-address" label="Адрес объекта">
                    <b-form-input
                      type="text"
                      size="sm"
                      :disabled="isDisabled"
                      v-model="newItem.location_address"
                    />
                  </b-form-group>
                  <b-row class="align-items-end">
                    <b-col>
                      <b-form-group id="group-opened-date" label="Дата открытия вакансии">
                        <b-form-input
                          size="sm"
                          type="date"
                          :disabled="isDisabled"
                          v-model.date="newItem.opened_date"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="group-opened-date" label="Дата первого выхода в смену">
                        <b-form-input
                            size="sm"
                            type="date"
                            :disabled="isViewDisabled"
                            v-model.date="newItem.closed_date"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-form-group id="group-vacancy-text" label="Текст вакансии">
                    <b-form-textarea
                      type="text"
                      size="sm"
                      :rows="3"
                      resize
                      :disabled="isViewDisabled"
                      v-model="newItem.text"
                    />
                  </b-form-group>
                  <b-form-group id="group-organization" label="Организация">
                    <b-form-input
                      type="text"
                      size="sm"
                      :disabled="isDisabled"
                      v-model="newItem.organization_name"
                    />
                  </b-form-group>
                  <b-form-group id="group-assigned" label="Работодатель">
                    <b-form-select
                      type="text"
                      size="sm"
                      v-model="newItem.assigned"
                      :disabled="isViewDisabled"
                      :options="assignedOptions"
                    />
                  </b-form-group>
                  <b-form-group id="group-status" label="Статус">
                    <b-form-select
                      size="sm"
                      v-model="newItem.status"
                      :disabled="isViewDisabled"
                      :options="statusOptions"
                    />
                  </b-form-group>
                </b-card>
              </b-col>
              <b-col>
                <b-card bg-variant="light" class="h-100" body-class="d-flex flex-column">
                  <b-form-group id="group-provider-select" label="Сервис">
                    <b-form-select
                      type="text"
                      size="sm"
                      v-model="newItem.provider_id"
                      :options="providerOptions"
                      :disabled="isViewDisabled"
                    >
                      <template #first>
                        <b-form-select-option :value="0">Выберите сервис</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group id="group-business-area-select" label="Сфера деятельности">
                    <b-form-select
                      size="sm"
                      :disabled="isViewDisabled || !hasAvitoIntegration"
                      v-model="avitoData.business_area"
                    >
                      <option :value="null">Выберите сферу деятельности</option>
                      <option v-for="option in avitoDictionaries" :value="option.id">
                        {{ option.name }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group id="group-experience-select" label="Опыт работы">
                    <b-form-select
                      type="text"
                      size="sm"
                      v-model="avitoData.experience"
                      :options="experienceOptions"
                      :disabled="isViewDisabled"
                    >
                      <template #first>
                        <b-form-select-option value="">Укажите опыт работы</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group id="group-employment-select" label="Занятость">
                    <b-form-select
                      type="text"
                      size="sm"
                      v-model="avitoData.employment"
                      :options="employmentOptions"
                      :disabled="isViewDisabled"
                    >
                      <template #first>
                        <b-form-select-option value="">Выберите вид занятости</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group id="group-schedule-select" label="График">
                    <b-form-select
                      type="text"
                      size="sm"
                      v-model="avitoData.schedule"
                      :options="scheduleOptions"
                      :disabled="isViewDisabled"
                    >
                      <template #first>
                        <b-form-select-option value="">Выберите график работы</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group id="group-salary-input" label="Зарплата">
                    <b-row class="mb-3">
                      <b-col>
                        <b-form-input
                          type="number"
                          size="sm"
                          placeholder="От"
                          v-model.number="avitoData.salary.from"
                          :disabled="isViewDisabled"
                        />
                      </b-col>
                      <b-col>
                        <b-form-input
                          type="number"
                          size="sm"
                          placeholder="До"
                          v-model.number="avitoData.salary.to"
                          :disabled="isViewDisabled"
                        />
                      </b-col>
                    </b-row>
                    <b-form-group label="Картинка">
                      <b-form-file
                        ref="avitoImgInput"
                        :disabled="isViewDisabled || loading"
                        size="sm"
                        placeholder="Картинка не выбрана"
                        browse-text="Выбрать"
                        accept="image/*"
                        @change="onFileChange"
                      />
                      <div v-if="avitoData.static_image_url" class="mt-2">
                        <small>Загружено: <a :href="avitoData.static_image_url" target="_blank">{{ avitoData.static_image_url }}</a></small>
                      </div>
                    </b-form-group>
                  </b-form-group>
                    <div class="w-100 d-flex justify-content-end mt-auto">
                      <div
                        v-if="!hasAvitoIntegration && !loading && newItem.provider_id === 1"
                        class="alert alert-danger m-0 py-1 px-2 mr-2 d-flex align-items-center"
                        style="font-size: 0.85rem; border-style: dashed;"
                      >
                        <font-awesome-icon icon="exclamation-triangle" class="mr-1"/>
                        <span>У организации нет интеграции с Авито</span>
                      </div>
                      <b-button size="sm" variant="info" :disabled="loading || isViewDisabled || !hasAvitoIntegration || newItem.provider_id !== 1" @click="publishToAvito">
                        <b-spinner v-if="loading" small/>
                        <template v-else>
                          <font-awesome-icon :icon="avitoData && (avitoData.vacancy_id || avitoData.vacancy_uuid) ? 'arrow-alt-circle-up' : 'search-plus'" class="mr-1"/>
                          {{ avitoData && (avitoData.vacancy_id || avitoData.vacancy_uuid) ? 'Обновить объявление' : 'Опубликовать' }}
                        </template>
                      </b-button>
                    </div>
                </b-card>
              </b-col>
            </b-row>
          </b-form>
        </template>
      </b-skeleton-wrapper>
      <template>
        <div class="w-100 d-flex justify-content-end py-2">
          <b-button size="sm" variant="secondary" class="ml-auto mr-1" @click="hideModal">
            Отменить
          </b-button>
          <b-button size="sm" variant="success" :disabled="loading || isViewDisabled" @click="handleOk">
            <b-spinner v-if="loading" small/>
            <font-awesome-icon icon="save" class="mr-1"/>
            Сохранить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import recruitJobPostings from "../../network/recruitJobPostings";
import recruitTasks from "../../network/recruitTasks";
import catalogs from "../../network/catalogs";
import locations from "../../network/locations";
import locationVacancies from "../../network/locationVacancies";
import users from "../../network/users";
import avito from "../../network/avito";
import balansPro from "../../network/balansPro";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
    import RecruitTaskSelect from "./RecruitTaskSelect.vue";

export default {
  name: 'RecruitJobPosting',
  components: { RecruitTaskSelect },
  mixins: [
    recruitJobPostings, recruitTasks, catalogs, locations, users, locationVacancies, avito, balansPro,
    helpers, dateFormatter
  ],
  data() {
    return {
      title:`Объявление`,
      newItem: this.setNewItem(),
      avitoData: this.setNewAvitoData(),
      locationUsers: [],
      avitoDictionaries: [],
      isBusy: false,
      loading: false,
      isDisabled: true,
      isViewDisabled: true,
      recruitTaskIdDisabled: false,
      hasAvitoIntegration: false,
      statusOptions: [
        { value: 'created', text: 'Создано' },
        { value: 'in_progress', text: 'В работе' },
        { value: 'published', text: 'Опубликовано' },
        { value: 'canceled', text: 'Отменено' },
        { value: 'done', text: 'Готово' },
      ],
      providerOptions: [
        { value: 1, text: 'Авито' },
        { value: 2, text: 'HH (в разработке)', disabled: true }
      ],
      experienceOptions: [
        { value: 'noMatter', text: 'Без опыта' },
        { value: 'moreThan1', text: 'От 1 года' },
        { value: 'moreThan3', text: 'От 3 лет' },
        { value: 'moreThan5', text: 'От 5 лет' },
        { value: 'moreThan10', text: 'От 10 лет' },
      ],
      employmentOptions: [
        { value: 'full', text: 'Постоянная' },
        { value: 'partial', text: 'Частичная' },
        { value: 'temporary', text: 'Временная' },
        { value: 'internship', text: 'Стажировка' },
      ],
      scheduleOptions: [
        { value: 'fixed', text: 'Фиксированный' },
        { value: 'flexible', text: 'Гибкий' },
        { value: 'shift', text: 'Сменный' },
        { value: 'flyInFlyOut', text: 'Вахта' },
      ],
    }
  },
  computed: {
    assignedOptions() {
      if (!this.locationUsers || this.locationUsers.length === 0) return [];

      return this.locationUsers.map(u => ({
        value: u.id,
        text: u.name + ` (${u.role_name})`
      }));
    },
    selectDisabled() {
      return (this.newItem.id > 0) || this.recruitTaskIdDisabled;
    }
  },
  async mounted() {
    const recruitTaskId = this.$route.params.recruitTaskId;
    this.recruitTaskIdDisabled = this.$route.params.recruitTaskDisabled;
    this.isViewDisabled = this.$route.query.mode === 'view';

    if (recruitTaskId) {
      await this.fillJobPosting(recruitTaskId);
    }
  },
  methods: {
    setNewItem() {
      return {
        id: 0,
        recruit_task_id: 0,
        provider_id: 0,
        provider_name: '',
        provider_post_id: null,
        provider_post_uuid: null,
        provider_post_status: '',
        provider_published_date: null,
        assigned: 0,
        status: 'created',
        text: '',
        location_id: 0,
        location_name: '',
        location_address: '',
        location_vacancy_id: 0,
        location_vacancy_name: '',
        opened_date: null,
        closed_date: null,
        organization_id: 0,
        organization_name: '',
      };
    },
    setNewAvitoData() {
      return {
        id: null,
        business_area: null,
        experience: 'noMatter',
        employment: 'full',
        schedule: 'shift',
        location: '',
        salary: {
          to: null,
          from: null
        },
        static_image_url: '',
        vacancy_id: '',
        vacancy_uuid: '',
        vacancy_status: '',
        last_error: '',
        last_synced_at: null
      };
    },
    resetState() {
      this.newItem = this.setNewItem();
      this.avitoData = this.setNewAvitoData();
      this.avitoDictionaries = [];
      this.locationUsers = [];
      this.hasAvitoIntegration = false;
    },
    async showModal(jobPostingId, isView) {
      this.isViewDisabled = isView;
      this.resetState();
      this.$refs.modal_recruit_job_posting.show();

      if (jobPostingId) {
        await this.getJobPosting(jobPostingId);
      }
    },
    hideModal() {
      this.$refs.modal_recruit_job_posting.hide();
    },
    handleOk() {
      this.handleSubmit();
      this.hideModal();
    },
    onHidden() {
      this.resetState();
      this.recruitTaskIdDisabled = false;
      this.isViewDisabled = true;
      this.$emit('modal-closed');
    },
    async getJobPosting(jobPostingId) {
      this.isBusy = true;
      this.loading = true;

      const result = await this.getJobPostingById(jobPostingId);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.isBusy = false;
        this.loading = false;
        return;
      }

      this.newItem = result.data;
      this.newItem.opened_date = this.formattedFromServerDate(this.newItem.opened_date);
      this.newItem.closed_date = this.formattedFromServerDate(this.newItem.closed_date);
      this.newItem.provider_published_date = this.formattedFromServerDate(this.newItem.provider_published_date);

      await this.getLocationUsersAndOrganization(this.newItem.location_id);
      this.hasAvitoIntegration = await this.checkAvitoIntegration(this.newItem.organization_id);

      if (this.hasAvitoIntegration) {
        await this.getIntegrationDictionaries(this.newItem.organization_id);
        await this.getIntegrationData(this.newItem.id);
      } else {
        this.avitoDictionaries = [];
        this.avitoData = this.setNewAvitoData();
      }

      this.isBusy = false;
      this.loading = false;
    },
    async fillJobPosting(recruitTaskId) {
      this.isBusy = true;
      this.loading = true;
      const result = await this.getRecruitTaskById(recruitTaskId);

      if (result.data) {
        const task = result.data;

        this.newItem.recruit_task_id = task.id;
        this.newItem.location_id = task.location_id;
        this.newItem.location_name = task.location_name;
        this.newItem.location_vacancy_id = task.location_vacancy_id;
        this.newItem.location_vacancy_name = task.location_vacancy_name;
        this.newItem.opened_date = this.formattedFromServerDate(task.opened_date);
        this.newItem.closed_date = this.formattedFromServerDate(task.closed_date);
        this.newItem.provider_published_date = this.formattedFromServerDate(task.provider_published_date);
        this.newItem.assigned = task.assigned;
        this.newItem.text = task.text

        await this.getLocationUsersAndOrganization(task.location_id);
        this.hasAvitoIntegration = await this.checkAvitoIntegration(this.newItem.organization_id);
        this.hasAvitoIntegration ? await this.getIntegrationDictionaries(this.newItem.organization_id) : this.avitoDictionaries = [];
      }

      this.$refs.modal_recruit_job_posting.show();
      this.isBusy = false;
      this.loading = false;
    },
    async getLocationUsersAndOrganization(locationId) {
      if (!locationId) {
        this.locationUsers = [];
        return;
      }

      const location = await this.getLocationById(locationId);

      if (location && location.data) {
        this.newItem.organization_id = location.data.organization_id;
        this.newItem.organization_name = location.data.organization_name;
        this.newItem.location_address = location.data.address;
        this.avitoData.location = this.newItem.location_address;

        const uniqueUserIds = [...new Set(location.data.location_users.map(item => item.user_id))];
        const promises = uniqueUserIds.map(id => this.getUserById(id));
        const result = await Promise.all(promises);

        this.locationUsers = result.map(res => res.data)
      } else {
        this.locationUsers = [];
      }
    },
    async handleSubmit() {
      this.loading = true;

      const data = this.newItem;
      data.opened_date = this.formattedToServerDate(data.opened_date);
      data.closed_date = this.formattedToServerDate(data.closed_date);
      data.provider_published_date = this.formattedToServerDate(data.provider_published_date);

      const provider = this.providerOptions.find(option => option.value === data.provider_id);
      if (provider) this.newItem.provider_name = provider.text;

      const method = (data.id > 0) ? this.putJobPosting : this.postJobPosting;
      const result = await method(data);

      if (!result || !result.data) {
        this.showError("Не удалось сохранить данные.");
        this.loading = false;
        return;
      }

      this.newItem.id = result.data.id;
      this.loading = false;
      this.$emit('refresh');
    },
    async onRecruitTaskIdSelect(recruitTaskId) {
      this.newItem.recruit_task_id = recruitTaskId;

      if (recruitTaskId) {
        await this.fillJobPosting(recruitTaskId);
      }
    },
    onClearSelected() {
      this.resetState();
    },
    // Integration
    async checkAvitoIntegration(organizationId) {
      if (!organizationId) return false;

      const result = await this.getOrganizationIntegrations(organizationId);

      if (result && result.data && result.data.id) {
        return !!(result.data.avito_client_id || result.data.avito_client_secret);
      }

      return false;
    },
    async getIntegrationDictionaries(organizationId) {
      const data = {
        organization_id: organizationId,
        dictionary_id: 'business_area'
      }

      const result = await this.getAvitoDictionaries(data);
      this.avitoDictionaries = (result && result.data) ? result.data : [];
    },
    async getIntegrationData(jobPostingId) {
      const result = await this.getJobPostingAvitoIntegration(jobPostingId);

      if (!result || !result.data) {
        if (result.status !== 400) {
          this.showError("Ошибка при получении данных интеграции.");
        }
        this.isBusy = false;
        this.loading = false;
        return;
      }

      const avitoData = result.data;
      const payload = avitoData.payload;

      this.avitoData = {
        id: avitoData.id,
        vacancy_id: avitoData.vacancy_id,
        vacancy_uuid: avitoData.vacancy_uuid,
        vacancy_status: avitoData.vacancy_status,
        last_error: avitoData.last_error,
        last_synced_at: avitoData.last_synced_at,

        business_area: payload ? payload.business_area : null,
        experience: payload ? payload.experience : 'noMatter',
        employment: payload ? payload.employment : 'full',
        schedule: payload ? payload.schedule : 'shift',
        location: payload ? payload.location : '',
        salary: {
          from: payload ? payload.salary.from : null,
          to: payload ? payload.salary.to : null
        },
        static_image_url: payload ? payload.static_image_url : ''
      };

      this.isBusy = false;
      this.loading = false;
    },
    async publishToAvito() {
      if (!this.newItem.id) {
        this.showSubmitError("Сначала сохраните объявление, прежде чем публиковать его.");
        return;
      }

      if (!this.avitoData.business_area) {
        this.showSubmitError("Выберите сферу деятельности.");
        return;
      }

      this.loading = true;

      const wrappedData = {
        template_code: 'raw_v2',
        payload: {
          title: this.newItem.location_vacancy_name,
          billing_type: 'packageOrSingle',
          business_area: this.avitoData.business_area,
          description: this.newItem.text,
          employment: this.avitoData.employment,
          experience: this.avitoData.experience,
          schedule: this.avitoData.schedule,
          location: this.avitoData.location,
          salary: {
            to: this.avitoData.salary.to !== null ? Number(this.avitoData.salary.to) : null,
            from: this.avitoData.salary.from !== null ? Number(this.avitoData.salary.from) : null
          },
          static_image_url: this.avitoData.static_image_url || null,
        },
      };

      const method = (this.avitoData && (this.avitoData.vacancy_id || this.avitoData.vacancy_uuid)) ? this.updateJobPostingAvitoExternal : this.publishJobPostingAvito;
      const result = await method(this.newItem.id, wrappedData);

      if (!result || !result.data) {
        this.showError("Не удалось опубликовать объявление.");
        this.loading = false;
        return;
      }

      this.showSuccess("Объявление успешно опубликовано на Авито.");
      await this.getJobPosting(this.newItem.id);
      this.$emit('refresh');
      this.loading = false;
    },
    async onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (this.newItem.id === 0) {
        this.showError("Сначала сохраните объявление, прежде чем загружать картинку.");
        return;
      }

      this.loading = true;
      const formData = new FormData();
      formData.append('image', file);
      const result = await this.postJobPostingFile(this.newItem.id, formData);

      if (result.error) {
        this.showError("Ошибка при загрузке изображения");
      } else {
        this.$set(this.avitoData, 'static_image_url', result.data.url);
        this.showSuccess("Картинка успешно загружена");
      }

      this.loading = false;
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Recruiting/RecruitJobPosting.vue